const restaurantReducer = (
  state = {
    restaurant_name: "",
    restaurant_category: "",
    phone: "",
    cover: "",
    address: {
      label: "",
      city: "",
      postcode: "",
      street: "",
      housenumber: "",
      context: "",
      x: "",
      y: "",
    },
    croppedImageUrl: "",
  },
  action
) => {
  if (action.type === "NEXT_PHASE_RESTAURANT") {
    let restaurant_name = action.payload.restaurant_name;
    let restaurant_category = action.payload.restaurant_category;
    let phone = action.payload.phone;
    console.log({ restaurant_name });
    console.log({ restaurant_category });
    console.log({ phone });

    return { ...state, restaurant_name, restaurant_category, phone };
  } else if (action.type === "ADD_COVER_ADDRESS") {
    console.log("The restaurant location", action.payload.location);

    let label = action.payload.location.label;
    let city = action.payload.location.city;
    let postcode = action.payload.location.postcode;
    let street = action.payload.location.street;
    let housenumber = action.payload.location.housenumber;
    let context = action.payload.location.context;
    let x = action.payload.location.x;
    let y = action.payload.location.y;
    return {
      ...state,
      address: { label, city, postcode, street, housenumber, context, x, y },
    };
  } else if (action.type === "ADD_UPLOAD_CROPED_IMG") {
    console.log("ADD_UPLOAD_CROPED_IMG", action.payload);
    return { ...state, croppedImageUrl: action.payload };
  } else {
    return state;
  }
};

export default restaurantReducer;
